import { createOperationsGenerator, defineProvider } from '@nuxt/image/runtime'
import { joinURL, encodePath, encodeParam, parseURL } from 'ufo'

const operationsGenerator = createOperationsGenerator({
    keyMap: {
        format: 'f',
        fit: 'fit',
        width: 'w',
        height: 'h',
        resize: 's',
        quality: 'q',
        background: 'b'
    },
    joinWith: '&',
    formatter: (key:string, val:string) => encodeParam(key) + '_' + encodeParam(val)
})

export function getImage(src: string, { modifiers }: { modifiers: Record<string, unknown> }) {
  const params = operationsGenerator(modifiers) || '_'

  const appConfig = useAppConfig();
  const { integrations } = appConfig

   const baseURL = integrations.ipxUrl || useRuntimeConfig().public.IPX_SERVICE_URL

  const crmUrl = useRuntimeConfig().public.CRM_URL
  const landingUrl = useRuntimeConfig().public.LANDING_URL

  const parsedUrl = parseURL(src)

  const isCrmHosted = parsedUrl.host === parseURL(crmUrl).host
  const isLandingHosted = parsedUrl.host === parseURL(landingUrl).host

  const isAbsolute = !parsedUrl.host

  const isApiUrl = parsedUrl.pathname.startsWith('/b')
  if (isApiUrl) {
    const newUrl = joinURL(baseURL, params, encodePath(`a${parsedUrl.pathname.replace('/b', '')}`));
    return {
      url: newUrl,
    }
  }

  if (isAbsolute) {
    const newUrl = joinURL(baseURL, params, encodePath(`c${src}`));
    return {
      url: newUrl,
    }
  }


  if (isCrmHosted) {
    const newUrl = joinURL(baseURL, params, encodePath(`c${parsedUrl.pathname}`));
    return {
      url: newUrl,
    }
  }

  if (isLandingHosted) {
    const newUrl = joinURL(baseURL, params, encodePath(`l${parsedUrl.pathname}`));
    return {
      url: newUrl,
    }
  }

  const newUrl = joinURL(baseURL, params, isAbsolute ? encodePath(`${crmUrl}${src}`) : encodePath(src))
  return {
    url: newUrl
  }
}

export default defineProvider({ getImage })
